import { useTranslation } from 'react-i18next';

export interface RememberMeFieldProps {
  checked: boolean;
  onChange: (next: boolean) => void;
  /**
   * When Functional cookies are still off, checking this box should grant them
   * (login persistence) without opening the full CMP banner.
   */
  onEnablePersistence: () => void;
  disabled?: boolean;
  /** Stable id when multiple remember-me fields can mount (e.g. confirm-email). */
  inputId?: string;
}

export function RememberMeField({
  checked,
  onChange,
  onEnablePersistence,
  disabled = false,
  inputId = 'remember-me',
}: RememberMeFieldProps): JSX.Element {
  const { t } = useTranslation('customer');
  return (
    <div className="flex items-center gap-2 text-sm">
      <input
        id={inputId}
        type="checkbox"
        className="h-4 w-4 accent-[var(--color-accent)]"
        checked={checked}
        disabled={disabled}
        data-testid="customer-auth-remember-me"
        onChange={(e) => {
          const next = e.target.checked;
          if (next) {
            onEnablePersistence();
          }
          onChange(next);
        }}
      />
      <label htmlFor={inputId} className="text-[var(--color-on-surface)]">
        {t('auth.rememberMe')}
      </label>
    </div>
  );
}
